const firebaseConfig = {
	apiKey: 'AIzaSyC-vLVKz49NQOLSUf7ikG4zS1AlBP8HrHI',
	authDomain: 'diabetic-net-4e4f6.firebaseapp.com',
	projectId: 'diabetic-net-4e4f6',
	storageBucket: 'diabetic-net-4e4f6.appspot.com',
	messagingSenderId: '787974753583',
	appId: '1:787974753583:web:018b89688383cc98ebe5da',
};

export default firebaseConfig;
